import styled from 'styled-components';
import { FONT_FAMILY, COLORS } from '@Commons';

export const Text = styled.div`
  color: ${COLORS.textLightGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const TimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
`;

export const Label = styled.h5`
  color: ${COLORS.disabled};
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const Value = styled.p`
  color: ${COLORS.textLightGrey};
  font-family: ${FONT_FAMILY.hellix.bold};
  line-height: 22px;
  margin-left: 5px;
  font-size: 12px;
  font-style: normal;
`;
